/*
 * 获取列表Voip管理列表
 * *
 * */
import { nxExtenManageClient } from "@/api/index";
import { OperateNxteleReq, NxteleListReq, XExtenListReq } from "@/pbjs/xcommon/nxExtenManage_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "@/request/request";
export interface Options {
    UserGroupId?: number;
    PayrollCycleCondition?: number;
    IsNewEmployee?: number;
    EmployeeId?: string;
    EmployeeName?: string;
    Page: Page;
}
// 获取Voip管理列表
export function setNxteleListReq(arg: Options) {
    let request:any = new NxteleListReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setName('');
    request.setAppkey('');
    request.setSecretkey('');
    request.setBelong('');
    request.setSystemtype('');
    return request;
}
export const getNxteleListRequest = new InnerRequest(
    nxExtenManageClient,
    nxExtenManageClient.nxteleList
);
// 保存Voip管理
export interface OperateOptions {
    UserGroupId?: number;
    PayrollCycleCondition?: number;
    IsNewEmployee?: number;
    EmployeeId?: string;
    EmployeeName?: string;
    Page: Page;
}
export function setOperateNxteleReq(arg: any) {
    let request:any = new OperateNxteleReq();
    request.setOperate(arg.operate);
    request.setName(arg.attrValueForm.name);
    request.setAppkey(arg.attrValueForm.appKey);
    request.setSecretkey(arg.attrValueForm.secretKey);
    request.setBelong(arg.attrValueForm.belong);
    request.setSalt(arg.attrValueForm.salt);
    request.setCompanycode(arg.attrValueForm.companyCode);
    request.setSystemtype(arg.attrValueForm.systemType);
    request.setId(arg.editId);
    return request;
}
export const getOperateNxteleRequest = new InnerRequest(
    nxExtenManageClient,
    nxExtenManageClient.operateNxtele
);
// 获取分机管理列表
export function setExtenListReq(arg: any) {
    let request:any = new XExtenListReq();
    request.setPagein(setPage(arg.pageIndex, arg.pageSize));
    request.setUsername(arg.UserName);
    request.setSupplier(arg.Supplier);
    request.setAssignstatus(arg.AssignStatus);
    request.setExtnumber(arg.ExtNumber);
    request.setAddstarttime(arg.Addstarttime);
    request.setAddendtime(arg.Addendtime);
    request.setSearchstart(arg.SearchStart);
    request.setSearchend(arg.SearchEnd);
    request.setExtuser(arg.Extuser)
    return request;
}
export const getXExtenListRequest = new InnerRequest(
    nxExtenManageClient,
    nxExtenManageClient.getExtenList
);